﻿/* globals SolicitudDTO */
var jquery = require('jquery');
var mailcheck = require('mailcheck');
var HabEvents = require("../../Global/habitaclia-events");
var storageService = require("../../Global/storage-service").default;
var leadTrace = require('../../Common/Lead/lead-trace');
var parse = require('../../Common/Lead/lead-parser');
var captchaService = require('../../Common/Captcha/captcha-service');
var trackLeadSubmission = require('../../Common/Lead/lead-tracking');

/*TODO: Dídac -> se deberían poner todas las variables globales que se puedan como this.__variable dentro de la inicialización*/
(function () {
    "use strict";
    var __SolicitudDTO;
    var __stringRespuestaError = "stop";
    var __idInputNombre = "#Nombre";
    var __idInputTelefono = "#Telefono";
    var __idInputEmail = "#Email";
    var __idInputMensaje = "#Mensaje";
    var __idErrorNombre = "#nombreError";
    var __idErrorCaptcha = "#captchaError";
    var __idErrorTelefono = "#telefonoError";
    var __idErrorEmail = "#emailError";
    var __idLegalError = "#legalError";
    var __idAvisoLegalContactar = "#idCheckLegalContactar";
    var __idLabelLegalContactar = 'idLabelLegalContactar';
    var __expresionRegularMail = '^(([a-zA-Z0-9!#$%&*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&*+/=?^_`{|}~-]+)*)@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9]{2}(?:[a-zA-Z0-9-]*[a-zA-Z])?)$';
    var __expresionEspacioMail = '\s';
    var __stringRespuestaErrorSinSessionASP = "errorcaptcha";
    var __stringRespuesaErrorBlackList = "<!-- ajv -->";
	var __stringRespuestaMsa = "<!-- msa -->";
	var __stringResponseSpamIndex = "<!-- spi -->";
    /*TODO: Dídac ->Usar una nueva propiedad del __SolicitudDto.EsParticular*/
    var __codEmpParticular = "500";
    var __errorSolicitudDiv = "<div class='mensaje stop'><h5>Lo sentimos ha habido un error con la solicitud, porfavor vuelva a intentarlo de nuevo</h5></div>";
    var __tamPixelsCabecera;
    var __expresionRegularTelefono = /^[0-9+//]+$/;
    var __textoErrorCaptcha = "El código de seguridad introducido no es correcto";
	var __textoErrorPeticionCaptcha = "Se ha producio un error al validar el código de seguridad";


    var Solicitud = function (solicitudDTO) {
        __SolicitudDTO = solicitudDTO;
		this.__$inputMensaje = jquery('#Mensaje');
        this.__$btnContSuperior = jquery('#js-cont-superior');
        this.__$btnContactarFormFichaDesktopYMobile = jquery('#submitSolicitudes');
        this.__$contactTopText = jquery('#js-contact-top-text');
        this.__$lnkVerTelefono = jquery('#js-lnk-ver-telefono');
        this.__$lnkVerTelefonoActivado = jquery('#js-ver-telefono-activado');
        this.__labelLegal = document.getElementById(__idLabelLegalContactar);
        this.__checkLegal = document.getElementById('idCheckLegalContactar');
        this.__phone;
        this.__email;
        this.__name;
        this.__maxTime = 2592000;
        this.__telRegEx = /(\+?\d{1,20})/gm;

        trackLeadSubmission.observeForm(document.getElementById('solicitudesForm'));
        __registerEvents.call(this);
    	this.__$header = jquery("#header");

    	__tamPixelsCabecera = this.__$header.height() + 20;
    	this.__esPrimeraVezFocus = true;
    	this.__storageService = new storageService(window.localStorage);
    	if (this.__storageService.checkLocalStorage()) {
    	    __registerStorageEvents.call(this);
    	    __getDataFromStorage.call(this);
    	}
    };

    var __registerStorageEvents = function () {
        var self = this;
        var date = new Date();
        jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, () => self.__storageService.setItem('keepForm', { 'phone': self.__phone, 'email': self.__email, 'name': self.__name, 'date': date.getTime() }));
        jquery.subscribe(HabEvents.EventsEnum.LogOut, () => self.__storageService.removeItem('keepForm'));
    };

    var __getDataFromStorage = function () {
        var lastFormData = this.__storageService.getItem('keepForm');
        var actualDate = new Date();
        var actualTime = actualDate.getTime();
        var resTime = actualTime - lastFormData.date;

        if (lastFormData) {
            if (resTime < this.__maxTime || __SolicitudDTO.ULoggued === 'True') {
                jquery(__idInputTelefono).val(lastFormData.phone);
                jquery(__idInputEmail).val(lastFormData.email);
                jquery(__idInputNombre).val(lastFormData.name);
                __hideLegal.call(this);
            } else {
                this.__storageService.removeItem('keepForm');
            }
        }
    };

    var __showLegal = function () {
        if (this.__labelLegal && this.__labelLegal.style.display === 'none') {
            this.__labelLegal.style.display = '';
            this.__checkLegal.checked = false;
        }
    };

    var __hideLegal = function () {
        if (this.__labelLegal) {
            this.__labelLegal.style.display = 'none';
        }
        this.__checkLegal.checked = true;
    };

    var __checkStoredData = function () {
        var lastFormData = this.__storageService.getItem('keepForm');
        if (lastFormData && lastFormData.phone === jquery(__idInputTelefono).val() && lastFormData.email === jquery(__idInputEmail).val()) {
            __hideLegal.call(this);
        } else {
            __showLegal.call(this);

        }
    };

    var __registerEvents = function () {
        var self = this;

        this.__$btnContSuperior.click(function () {
            jquery.publish(HabEvents.EventsEnum.IrAFormularioContacto);

            if (self.__$contactTopText.val().length > 0) {
                self.__$inputMensaje.val(self.__$contactTopText.val());

                if (__SolicitudDTO.idUsuario > 0) {
                    jquery('#solicitudesForm').submit();
                }
            }
        });

        this.__$lnkVerTelefono.click(function () {
            jquery.publish(HabEvents.EventsEnum.ClickVerTelefonoFicha);
        });

        this.__$lnkVerTelefonoActivado.click(function () {
            __verTelefono.call();
            jquery.publish(HabEvents.EventsEnum.ClickVerTelefonoFicha);
        });

        this.__$btnContactarFormFichaDesktopYMobile.click(function () {
            self.__phone = document.getElementById('Telefono').value;
            self.__email = document.getElementById('Email').value;
            self.__name = document.getElementById('Nombre').value;
            jquery.publish(HabEvents.EventsEnum.ClickContactarFicha, ['contactarform']);
        });

        jquery(__idInputEmail).keyup(function (e) {
            e.preventDefault();
            __mailCheckSuggest();
		});

        jquery(__idInputEmail).blur(function (e) {
            e.preventDefault();
            if (__esEmailSolicitudValido(e)){
                __hideErrorCamposFormulario(__idErrorEmail);
            }
            __checkStoredData.call(self);
        });

        jquery(__idInputTelefono).blur(function (e) {
            e.preventDefault();
            if (__esTelefonoSolicitudValido(e)) {
                __hideErrorCamposFormulario(__idErrorTelefono);
            }
            __checkStoredData.call(self);
        });

        jquery(__idInputNombre).blur(function (e) {
            e.preventDefault();
            if (__esNombreSolicitudValido(e)) {
                __hideErrorCamposFormulario(__idErrorNombre);
        }
        });

        jquery(__idAvisoLegalContactar).change(function (e) {
            e.preventDefault();
            if (__esAvisoLegalChecked(e)) {
                __hideErrorCamposFormulario(__idLegalError);
            }
        });

        jquery("#solicitudesForm input, #solicitudesForm textarea").focus(function () {
            if (self.__esPrimeraVezFocus) {
                var selectorGtm = ".gtmproductcheckout";
                jquery.publish(HabEvents.EventsEnum.FocusToSolicitud, [selectorGtm]);
                self.__esPrimeraVezFocus = false;
        }
        });

        jquery("#alertaSolicitud.testABGi").click(function () {
        	var sAction = "recibir";
        	if (!jQuery("#alertaSolicitud").is(":checked")) {
        		sAction = "no-recibir";
        	}
        	jquery.publish(HabEvents.EventsEnum.RecibirAlertasSolicitud, [sAction, 'inmuebles-similares']);
        });
    };


    var __getUrlSolicitud = function(codigoAnuncio){
    	return __SolicitudDTO.UrlAjaxContactarAsp.replace('{0}', codigoAnuncio);
    };


    var __ajaxSolicitudSimilarToAsp = function (codigoAnuncioSimilar) {
        trackLeadSubmission('attempted');
    	var self = this;

		//TODO tenemos que modificar algun dato de este objeto
    	this.solicitudAspData.descripcion_net = __SolicitudDTO.Translate.ContactedSimilarMessage;
        this.solicitudAspData.isSimilar = true;
        this.solicitudAspData.alertaOrigen = 3;

    	var reqAsp = jquery.ajax({
    		type: "POST",
    		url: __getUrlSolicitud.call(this, codigoAnuncioSimilar),
    		data: this.solicitudAspData,
    		dataType: "text"
    	});

		reqAsp.done(function (data) {

			var $data = jquery(data);
            var $telefonoContacto = $data.find('.contactotelf');
            var outcome = parse.SubmissionOutcome(data);
            trackLeadSubmission(outcome.result, outcome.reason);
            var $telephoneText = $telefonoContacto.find('telefono_contacto');
            __checkTelephone.call(self, $telephoneText, $telefonoContacto);
    		var telefono = $telefonoContacto.html();
            var feedbackContacted = '<span class="sim-contact-msg">'+__SolicitudDTO.Translate.ContactedSimilar+'</span>';
            var $btnClicked = jquery('#simsol'+codigoAnuncioSimilar);
            $btnClicked.after(telefono);
            jquery($btnClicked.siblings('.ico-llamar')).after(feedbackContacted);
            $btnClicked.remove();
            var item = document.getElementById('id' + codigoAnuncioSimilar);
            jquery.publish(HabEvents.EventsEnum.SegmentTrackLead, { isDetail: false, codigoAnuncio: codigoAnuncioSimilar, dataSet: item.dataset, realEstateAdId: __SolicitudDTO.realEstateAdId });
    	});
        reqAsp.fail(function () { trackLeadSubmission('failed', 'NETWORK_ERROR'); });


    };

    var __checkTelephone = function ($telephoneText, $telefonoContacto) {
        if ($telephoneText.length > 0) {
            var rawTelephone = $telephoneText[0].innerText;
            var telephones = this.__telRegEx.exec(rawTelephone);
            if (telephones) {
                var $telephoneAnchors = jquery($telefonoContacto[0]).find('a');
                if ($telephoneAnchors && $telephoneAnchors.length > 0) {
                    Array.from($telephoneAnchors).forEach(telephone => telephone.href = 'tel:' + telephones[0]);
                }
            }

        }
    };

    var __ajaxSolicitudToAsp = function (starskyyhash, gtmcoupon) {

        var self = this;

        this.solicitudAspData = __getSolicitudASPData(starskyyhash, gtmcoupon);

        jquery("#submitSolicitudes").prop('disabled', true);

        __mostrarLoading.call();

        var reqAsp = jquery.ajax({
            type: "POST",
            url: __getUrlSolicitud.call(this, __SolicitudDTO.CodigoAnuncio),
            data: this.solicitudAspData,
            dataType: "text"
        });

        reqAsp.done(function (data) {
        	__ocultarLoading.call();

			var parsedResponse = parse.Lead(data);
			var respuestaAspParseada = "";

			if (parsedResponse.status === 200) {
				respuestaAspParseada = parsedResponse.data.content;
				if (!parsedResponse.data.hasOwnProperty("solicitudViewModel")) {
					parsedResponse.data.solicitudViewModel = __fillSolicitudViewModelFromDataForm();
				}
			}

			if (respuestaAspParseada === "")
			{
				jquery("#formularioSolicitudDiv").show();
				jquery("#submitSolicitudes").prop("disabled", false);
				leadTrace.Error(parsedResponse.data.solicitudViewModel, leadTrace.ErrorType.ParsedResponse);
                __showErrorDefectoSolicitud();
			}
            else {
                var esRespuestaIncorrectaSinSessionASP = __getEsRespuestaErrorSinSessionASP(respuestaAspParseada);
				if (esRespuestaIncorrectaSinSessionASP) {
					leadTrace.Error(parsedResponse.data.solicitudViewModel, leadTrace.ErrorType.NoSession);
                    location.reload();
                }
                else {
                    var esRespuestaErrorFormulario = __getEsRespuestaError(respuestaAspParseada);
                    if (esRespuestaErrorFormulario) {
                        jquery("#submitSolicitudes").prop('disabled', false);
						leadTrace.Error(parsedResponse.data.solicitudViewModel, leadTrace.ErrorType.FormDataError);
                        __showError_RespuestaASP(respuestaAspParseada);
                    }
                    else {
                        var esRespuestaBlackList = __getEsRespuestaDeBlackList(respuestaAspParseada);
						var esRespuestaMSA = __getEsRespuestaDeMsa(respuestaAspParseada);
						var isResponseSpamIndex = __getIsResponseFromSpamIndex(respuestaAspParseada);
                        __ocultarElementosFormularioSolicitudes();
                        var divSolicitudRespuesta;
						if (esRespuestaBlackList || isResponseSpamIndex) {
							/* TODO: Add new value spamIndex to MotivossolicitudErrorEnum */
							var errorType = esRespuestaBlackList ? leadTrace.ErrorType.BlackList : leadTrace.ErrorType.SpamIndex;
							leadTrace.Error(parsedResponse.data.solicitudViewModel, errorType);
                        	divSolicitudRespuesta = document.getElementById("respuestaSolicitud");
                        	divSolicitudRespuesta.innerHTML = respuestaAspParseada;
                        	__repintarCajaContactarFlotante.call(self, respuestaAspParseada);
                        	__repintarAccesosFavorios.call(self);
                        	jquery("#respuestaSolicitud").show();
                        }
						else if (esRespuestaMSA) {
							leadTrace.Error(parsedResponse.data.solicitudViewModel, leadTrace.ErrorType.PotentialMassiveAttack);
                            window.location.reload(true);
                        }
                        else {
                            var outcome = parse.SubmissionOutcome(respuestaAspParseada);
                            trackLeadSubmission(outcome.result, outcome.reason);
                            var $similares;
                            var divSimilaresRespuesta;
							divSolicitudRespuesta = document.getElementById("respuestaSolicitud");
                            divSimilaresRespuesta = document.getElementById("js-respuesta-similares");
                            divSolicitudRespuesta.innerHTML = respuestaAspParseada;
                            $similares = jquery(divSolicitudRespuesta).find("#similares");
                            if ($similares.length > 0) {
                                $similares.remove();
                                $similares = jquery(respuestaAspParseada).find("#similares")[0];
                                divSimilaresRespuesta.innerHTML = $similares.innerHTML;
                            }
                            __repintarCajaContactarFlotante.call(self, respuestaAspParseada);
                            __repintarAccesosFavorios.call(self);
                            jquery("#respuestaSolicitud").show();
                            jquery("#js-contact .w-300px").addClass("delete-margin");
                            jquery.publish(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada);
                            jquery.publish(HabEvents.EventsEnum.AdWordsConversion);
                            jquery.publish(HabEvents.EventsEnum.SegmentTrackLead, { isDetail: true, codigoAnuncio: __SolicitudDTO.CodigoAnuncio, realEstateAdId: __SolicitudDTO.realEstateAdId });
                          
                            jquery('#js-respuesta-similares .sim-item').click(function () {
                                jquery.publish(HabEvents.EventsEnum.ClickQuieroContactenSimilares);
                            });
                            jquery('#js-respuesta-similares li .js-contact-sim').click(function (e) {
                            	jquery.publish(HabEvents.EventsEnum.ClickQuieroContactenSimilaresBtn);

                            	e.preventDefault();
                            	e.stopPropagation();
                            	var codigoAnuncioSimilar = jquery(this).attr('id').replace('simsol', '');
                            	__ajaxSolicitudSimilarToAsp.call(self, codigoAnuncioSimilar);

                            });

                        }
                    }
                    __checkTelephone.call(self, jquery('telefono_contacto'), jquery('.contactotelf'));
                }
                __scrollToRespuestaASP();
            }
        });

        reqAsp.fail(function () {
        	__ocultarLoading.call();
			jquery("#submitSolicitudes").prop('disabled', false);
			var oSolicitudViewModel = __fillSolicitudViewModelFromDataForm(leadTrace.ErrorType.AjaxResponseError);
			leadTrace.Error(oSolicitudViewModel, leadTrace.ErrorType.AjaxCallError);
            __showErrorDefectoSolicitud();
        });
    };

    var __mostrarLoading = function () {
    	jquery("#content, #js-contenido_ficha").addClass("opacity");
    	jquery(".loading_content").addClass("opacity_listado").css("display", "block");
        jquery('#formularioSolicitudDiv').addClass('u-op-03');
        jquery('#LoadingSolicitud').removeClass('hide-none');
    };

    var __ocultarLoading = function () {
    	jquery("#content, #js-contenido_ficha").removeClass("opacity");
    	jquery(".loading_content").removeClass("opacity_listado").css("display", "none");
        jquery('#LoadingSolicitud').addClass('hide-none');
        jquery('#formularioSolicitudDiv').removeClass('u-op-03');
    };

    var __repintarAccesosFavorios = function () {
        var $accesosFavorito = jquery('#js-accesos-favoritos');

        if ($accesosFavorito.length === 0) {
            $accesosFavorito = jquery('.accesos-favoritos');
        }

        if ($accesosFavorito && $accesosFavorito.length > 0) {
            $accesosFavorito.empty();
            $accesosFavorito.append('<span>Acabas de contactar</span><span>|</span><a href="' + __SolicitudDTO.HrefVerContactos + '" class="ver-contactos">Ver los contactos</a>');
        }
    };

    var __repintarCajaContactarFlotante = function (respuestaAspParseada) {
        var telefono = jquery(respuestaAspParseada).find('.tel-llamar').text();
        jquery('#js-ver-telefono').text(telefono);
        jquery('#js-container-ver-telefono').removeClass('ocultar');
        var $cajacontactar = jquery('#js-cajacontactar');
        $cajacontactar.html('');
        $cajacontactar.addClass('caja-contactado');
        jquery('#js-cajavertelefono').remove();
    };

    var __fillSolicitudViewModelFromDataForm = function () {
    	var captchaValue = jquery("#CaptchaInputText").val();
        var solicitudViewModel = {
            solicitudViewModel: {
                Nombre: jquery(__idInputNombre).val(),
                Telefono: jquery(__idInputTelefono).val(),
                Email: jquery(__idInputEmail).val(),
                Mensaje: jquery(__idInputMensaje).val(),
                URLSolicitud: __SolicitudDTO.UrlAjaxContactarAsp,
                RecordarDatosEnEquipo: jquery("#recordarDatos").is(":checked"),
                RecibirAlertasInmueblesSimilares: jquery("#alertaSolicitud").is(":checked"),
                EsSolicitudPromocion: __SolicitudDTO.EsSolicitudPromocion,
                Producto: {
                    Codigo: __SolicitudDTO.CodigoProducto,
                    Empresa: {
                        CodEmp: __SolicitudDTO.CodEmp
                    },
                    Oficina: {
                        Cod_Ofi: __SolicitudDTO.CodOfi
                    }
                },
                CaptchaSolicitud: captchaValue
            }
        };
        return solicitudViewModel;
    };

    var __getSolicitudASPData = function (starskyyhash, gtmcoupon) {
        var aspData = {
            nombre_net: window.escape(jquery(__idInputNombre).val()),
            telefono_usuario: jquery(__idInputTelefono).val(),
            email: jquery(__idInputEmail).val(),
            descripcion_net: window.escape(jquery(__idInputMensaje).val()),
            alertaSolicitud: jquery("#alertaSolicitud").is(":checked") === true ? 1 : 0,
            alertaOrigen: jquery("#id_alerta_origen").val(),
            starskyyhash: starskyyhash,
            gtmcoupon: gtmcoupon
        };
        return aspData;
	};

    var __getEsRespuestaError = function (aspResponseDataParseada) {
        return aspResponseDataParseada.indexOf(__stringRespuestaError) > -1;
    };

    var __getEsRespuestaErrorSinSessionASP = function (aspResponseDataParseada) {
        return aspResponseDataParseada.indexOf(__stringRespuestaErrorSinSessionASP) > -1;
    };

    var __getEsRespuestaDeBlackList = function (aspResponseDataParseada) {
        return aspResponseDataParseada.indexOf(__stringRespuesaErrorBlackList) > -1;
    };

    var __getEsRespuestaDeMsa = function (aspResponseDataParseada) {
        return aspResponseDataParseada.indexOf(__stringRespuestaMsa) > -1;
    };

    var __getIsResponseFromSpamIndex = function(aspResponseDataParsed) {
	    return aspResponseDataParsed.indexOf(__stringResponseSpamIndex) > -1;
    };

    var __validar_Y_Enviar_Solicitud = function () {
        trackLeadSubmission('attempted');
        jquery("#respuestaSolicitudErronia").hide();
        if (__validarCamposFormulario())
        {
            __validarCaptcha.call(this, __enviarForm_SiCaptchaEsValido);
        } else {
            trackLeadSubmission('failed', 'LOCAL_VALIDATION');
        }

    };

    var __verTelefono = function () {
        var self = this;
            jquery.ajax({
                type: 'POST',
                url: __SolicitudDTO.UrlVerTelefono,
                data: {
                    codEmp: __SolicitudDTO.CodEmp,
                    codOfi: __SolicitudDTO.CodOfi,
                    codProd: __SolicitudDTO.CodigoProducto
                },
                success: function (data) {
                    __callbackVerTelefono.call(self, data);
                }
            });
    };

    var __callbackVerTelefono = function (data) {
        if (data){
            if (data.MostrarTelefono === true) {
                jquery('#js-cajacontactar').remove();
                jquery('#js-cajavertelefono').remove();
                jquery('#js-datos-finca-ver-telefono').remove();
                var $divMostrarTelefono = jquery('<div name="telf" class="vertelefono sprite"><span class="ver-telefono-icono">' + data.Telefono + '</span></div>');
                $divMostrarTelefono.appendTo('#js-infooficina, #js-datos-finca-telefono');
            }
        }
    };

    var __validarCaptcha = function (resultadoValidacionCaptcha) {
        var self = this;
        
        // Get captcha data using existing function
        var captchaData = __getCaptachaData();
        
        // Use captcha service for validation (bypass mode - just passes through)
        captchaService.validateCaptcha(captchaData).then(function(captchaValuesDTO) {
            // Call validation endpoint
            jquery.ajax({
                type: "POST",
                url: __SolicitudDTO.UrlAjaxValidarCaptcha,
                data: captchaValuesDTO,
                success:function(data){
                    resultadoValidacionCaptcha.call(self, data);
                },
                error: function (jqXHR, textStatus) {
                    resultadoValidacionCaptcha.call(self, { error: textStatus });
                }
            });
        }).catch(function(error) {
            console.error('Captcha validation error:', error);
            resultadoValidacionCaptcha.call(self, { error: 'Captcha initialization failed' });
        });
    };

    var __validarCamposFormulario = function () {
        var formularioValido = true;
        var accumlateErrors = 'error';

        if (__esAvisoLegalChecked.call(this, undefined)) {
            __hideErrorCamposFormulario.call(this, __idLegalError);
        }
        else {
            formularioValido = false;
            accumlateErrors += '_avisolegal';
            jquery.publish(HabEvents.EventsEnum.ErrorAvisoLegal);
        }

    	if (__esNombreSolicitudValido.call(this, undefined)) {
    		__hideErrorCamposFormulario.call(this, __idErrorNombre);
    	}
    	else {
    	    formularioValido = false;
    	    accumlateErrors += '_nombre';
    	}

    	if (__esTelefonoSolicitudValido.call(this, undefined)) {
    		__hideErrorCamposFormulario.call(this, __idErrorTelefono);
    	}
    	else {
    	    formularioValido = false;
    	    accumlateErrors += '_telefono';
    	}

    	if (__esEmailSolicitudValido.call(this, undefined)) {
    		__hideErrorCamposFormulario.call(this, __idErrorEmail);
    	}
    	else {
    	    formularioValido = false;
    	    accumlateErrors += '_email';
    	}

    	if (formularioValido === false) {
    	    __scrollToRespuestaASP.call(this);
    	    jquery.publish(HabEvents.EventsEnum.ErroresForm, ['form-contactar_ficha', accumlateErrors]);
    		jquery.publish(HabEvents.EventsEnum.ErroresForm, ['form-contactar_ficha', 'datos incorrectos']);
    	}

    	return formularioValido;

    };

    var __enviarForm_SiCaptchaEsValido = function (resultadoValidacionCaptcha) {

    	var captchaValido = true;

    	if (resultadoValidacionCaptcha.error) {
    		__showErrorCamposFormulario.call(this, __idErrorCaptcha, __textoErrorPeticionCaptcha);
    		captchaValido = false;
    	}
    	else {
    		if (resultadoValidacionCaptcha.status) {
    			__hideErrorCamposFormulario.call(this, __idErrorCaptcha);
    		}
    		else {
    			__showErrorCamposFormulario.call(this, __idErrorCaptcha, __textoErrorCaptcha);
    			captchaValido = false;
    		}
    	}

    	if (captchaValido) {
			__ajaxSolicitudToAsp.call(this, resultadoValidacionCaptcha.starskyyhash, __SolicitudDTO.gtmcoupon);
        }
    	else
    	{
            trackLeadSubmission('failed', 'CAPTCHA_REQUIRED');
    	    jquery.publish(HabEvents.EventsEnum.ErroresForm, ['form-contactar_ficha', 'captcha']);
    	}
    };

    var __esNombreSolicitudValido = function (event) {
        var nombreSolicitud = jquery(__idInputNombre).val();
        var textoErrorNombre = "Muy corto, el anunciante no sabrá a quien dirigirse";
        if (event){
            if (nombreSolicitud && nombreSolicitud.length < 3) {
                __showErrorCamposFormulario(__idErrorNombre, textoErrorNombre);
                return false;
            }
        }
        else {
            if (nombreSolicitud === "" || (nombreSolicitud && nombreSolicitud.length < 3)) {
            __showErrorCamposFormulario(__idErrorNombre, textoErrorNombre);
            return false;
        }
        }
        return true;
    };

    var __esEmailSolicitudValido = function (event) {
        var emailSolicitud = jquery(__idInputEmail).val();
        var erEspacios = new RegExp(__expresionEspacioMail);
        if (erEspacios.test(emailSolicitud)) {
            emailSolicitud = emailSolicitud.split(' ').join('');
            jquery(__idInputEmail).val(emailSolicitud);
        }
        var textoErrorEmail = "El email es incorrecto";
        var textoErrorMailObligatorio = "El email es obligatorio";

        if (emailSolicitud && emailSolicitud !== "") {
            var expresionRegular = new RegExp(__expresionRegularMail);
            if (__tieneCarcteresNoPermitidos(emailSolicitud) || !expresionRegular.test(emailSolicitud)) {
                __showErrorCamposFormulario(__idErrorEmail, textoErrorEmail);
                return false;
            }
            return true;
        }
        else if (__SolicitudDTO.EsSolicitudSolvia === "True" && (!emailSolicitud || emailSolicitud && emailSolicitud === ""))
        {
            if (!event) {
            __showErrorCamposFormulario(__idErrorEmail, textoErrorMailObligatorio);
            return false;
        }
        }
        return true;
    };

    var __esAvisoLegalChecked = function () {
        var textoErrorAvisoLegalContactar = __SolicitudDTO.Translate.LegalObligatory;
        var isLegalContactarChecked = jquery(__idAvisoLegalContactar).prop('checked');

        if (!isLegalContactarChecked) {
        	__showErrorCamposFormulario(__idLegalError, textoErrorAvisoLegalContactar);
            return false;
        }
        return true;
    };

    var __tieneCarcteresNoPermitidos = function (string) {
        var bool = false;

        if (string.indexOf("<") > -1) {
            bool = true;
        }

        if (string.indexOf(">") > -1) {
            bool = true;
        }

        if (string.indexOf("/") > -1) {
            bool = true;
        }

        if (string.indexOf("\\") > -1) {
            bool = true;
        }

        return bool;
    };

    var __esTelefonoSolicitudValido = function (event) {
        var expresionRegular = new RegExp(__expresionRegularTelefono);
        var telefonoSolicitud = jquery(__idInputTelefono).val();
        var textErrorTelefonoObligatorio = "Añade un teléfono para que se puedan poner en contacto";
        var textErrorTelefonoIncorrecto = "El teléfono es incorrecto";
        if ((!telefonoSolicitud || telefonoSolicitud === "") && !event) {
            __showErrorCamposFormulario(__idErrorTelefono, textErrorTelefonoObligatorio);
            return false;
        }
        else if (telefonoSolicitud.length > 0 && telefonoSolicitud.length < 9 || telefonoSolicitud.length > 0 && !expresionRegular.test(telefonoSolicitud)) {
            __showErrorCamposFormulario(__idErrorTelefono, textErrorTelefonoIncorrecto);
            return false;
        }
        return true;

    };

    var __showErrorCamposFormulario = function (idCampo, textoError) {
        jquery(idCampo).text(textoError);
        jquery(idCampo).show();
    };

    var __showErrorDefectoSolicitud = function(){
        var divSolicitudRespuesta = document.getElementById("respuestaSolicitudErronia");
        divSolicitudRespuesta.innerHTML = __errorSolicitudDiv;
        jquery("#respuestaSolicitudErronia").show();
        __scrollToRespuestaASP();
    };

    var __showError_RespuestaASP = function (errorRespuesta) {
        var divSolicitudRespuesta = document.getElementById("respuestaSolicitudErronia");
        divSolicitudRespuesta.innerHTML = errorRespuesta;
        jquery("#respuestaSolicitudErronia").show();
        __scrollToRespuestaASP();
    };

    var __hideErrorCamposFormulario = function (idCampo) {
        jquery(idCampo).hide();
    };

    var __scrollToRespuestaASP = function () {
        if (!document.getElementById('js-detail-portal-wrapper')) {
            jquery("body,html").animate({ scrollTop: jquery("#solicitud").offset().top - __tamPixelsCabecera}, 1000);
        }
    };

    var __mailCheckSuggest = function () {
        var valueEmail = jquery("#Email").val();
        mailcheck.run({
            email: valueEmail,
            suggested: function (suggestion) {
                jQuery(".mailcheck").html("<span id='spanSugerenciaMailId' style='color:#000000;background:#ffe68c;'  onclick=\"jQuery('#Email').val('" + decodeURI(suggestion.full) + "');jQuery('.mailcheck').html('');jQuery('#filamail').attr('style','');jQuery('#emailError').hide();\">Quizás quiso decir " + decodeURI(suggestion.address) + "@<b>" + decodeURI(suggestion.domain) + "</b>? </span>");
                jQuery("#filamail").attr("style", "background:#ffe68c;");
            },
            empty: function () {
                jQuery(".mailcheck").html("");
                jQuery("#filamail").attr("style", "");
            }
        });
    };

    var __ocultarElementosFormularioSolicitudes = function () {
        jquery('#js-datos-finca-ver-telefono').hide();
        jquery("#formularioSolicitudDiv").hide();
        if (__SolicitudDTO.CodEmp === __codEmpParticular) {
            jquery("#tituloFormSolicitud").hide();
        }
    };

    var __getCaptachaData = function () {
        var captchaDataObject = {
            CaptchaInputText: '',
            CodigoAnuncio: __SolicitudDTO.CodigoAnuncio,
            siteKey: __SolicitudDTO.CaptchaSiteKey,
            action: 'SOLICITUD'
        };
        return captchaDataObject;
    };
    Solicitud.prototype = {
        constructor: Solicitud,
        Validar_Y_Enviar_Solicitud: __validar_Y_Enviar_Solicitud,
        VerTelefono: __verTelefono
    };

    if (window.SolicitudDTO && typeof module !== 'undefined' && module.exports) {
        module.exports = new Solicitud(SolicitudDTO);
    }
    else {
        window.Solicitud = Solicitud;
    }
}());